import * as React from 'react';
import {
  checkFormHasError,
  getFormHelperText,
  handleBlurFormField,
  handleChangeFormField,
} from 'ui/forms/formHelpers';
import { useField } from 'formik';
import TextField, { TextFieldProps } from 'ui/TextField';

type FormTextFieldProps = TextFieldProps & {
  name: string;
};

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
function FormTextField({ helperText, ...rest }: FormTextFieldProps) {
  const [field, meta] = useField(rest.name);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleChangeFormField(field, event, rest.onChange);

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) =>
    handleBlurFormField(field, event, rest.onBlur);

  const hasError = checkFormHasError(meta);
  const helperTextValue = getFormHelperText(hasError, meta, helperText);

  return (
    <TextField
      error={hasError}
      helperText={helperTextValue}
      {...field}
      {...rest}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
}

export default FormTextField;
